var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvoicesPageIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.90356 1.43024V3.90643C6.90356 4.07061 6.96879 4.22807 7.08488 4.34416C7.20097 4.46025 7.35843 4.52548 7.52261 4.52548H9.9988",
    stroke: "#828282",
    strokeWidth: 0.619048,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7606 12.5731H2.57013C2.24176 12.5731 1.92685 12.4427 1.69466 12.2105C1.46247 11.9783 1.33203 11.6634 1.33203 11.335V2.66833C1.33203 2.33997 1.46247 2.02505 1.69466 1.79287C1.92685 1.56068 2.24176 1.43024 2.57013 1.43024H6.90346L9.9987 4.52548V11.335C9.9987 11.6634 9.86826 11.9783 9.63607 12.2105C9.40388 12.4427 9.08897 12.5731 8.7606 12.5731Z",
    stroke: "#828282",
    strokeWidth: 0.928572,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.80762 3.90582H4.42666",
    stroke: "#828282",
    strokeWidth: 0.619048,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.80762 7.62012H7.5219",
    stroke: "#828282",
    strokeWidth: 0.619048,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28491 10.0975H7.52301",
    stroke: "#828282",
    strokeWidth: 0.619048,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicesPageIcon);
export default __webpack_public_path__ + "static/media/InvoicesPageIcon.09f98ec6cdfa166868dbb38ca4ad1bc5.svg";
export { ForwardRef as ReactComponent };